// extracted by mini-css-extract-plugin
export default {"containerMain":"CustomCheckbox_containerMain__TkbD6","container":"CustomCheckbox_container__rmtco","checkmark":"CustomCheckbox_checkmark__HiHoh"};